import { Link } from "react-router-dom";
import { films } from "@/mocks/films";
import { topics } from "@/mocks/topics";

const stats = [
  { label: "收录影片", value: `${films.length}`, unit: "部" },
  { label: "主题专题", value: `${topics.length}`, unit: "个" },
  { label: "类型标签", value: "14", unit: "类" },
];

export default function IntroSection() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-[1.15fr_1fr] gap-0">
          <div className="p-6 md:p-10">
            <p className="text-[11px] tracking-[0.24em] text-primary-600 uppercase mb-2 font-label">ABOUT THE ARCHIVE</p>
            <h2 className="font-heading text-xl md:text-2xl text-foreground-950 leading-snug">
              一个为影迷整理日本电影资料的索引站
            </h2>
            <p className="mt-4 text-sm md:text-[15px] leading-relaxed text-foreground-700">
              日本一级片致力于把散落在各处的影片信息整理成清晰的档案：上映年份、主创阵容、类型标签、剧情简介与相关推荐。
              我们不做资源分发，只专注于「让人更快找到想看的作品」这件事。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              分类页支持类型、年份与地区的组合筛选；详情页提供结构化资料与同类推荐；专题页则从时代、城市与情绪切入，
              给出更有编辑视角的片单。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="h-10 px-5 inline-flex items-center rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap hover:bg-primary-700 transition-colors"
              >
                了解网站定位
              </Link>
              <Link
                to="/category"
                className="h-10 px-5 inline-flex items-center rounded-md border border-background-300 text-foreground-800 text-sm whitespace-nowrap hover:border-primary-300 hover:text-primary-700 transition-colors"
              >
                开始浏览分类
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-3 lg:grid-cols-1 border-t lg:border-t-0 lg:border-l border-background-300">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="p-5 md:p-6 flex lg:flex-row flex-col lg:items-center lg:justify-between gap-1 lg:gap-4 border-r last:border-r-0 lg:border-r-0 lg:border-b lg:last:border-b-0 border-background-300"
              >
                <span className="text-xs text-foreground-600">{stat.label}</span>
                <span className="flex items-baseline gap-1">
                  <span className="font-heading text-2xl md:text-3xl text-primary-700">{stat.value}</span>
                  <span className="text-xs text-foreground-500">{stat.unit}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}